import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import EmployeeListService from "../../services/EmployeeListService";
const initialState = {
  data: {},
  columnConfig: [],
  status: "idle",
  formData: {
    benefits: [],
    tenantData: {},
    selectedContractor: {},
  },
};

export const fetchTenantData = createAsyncThunk(
  "tenantData",
  async (countryCode) => {
    const response = await EmployeeListService.getTenantData(countryCode);
    return response;
  }
);

export const fetchEmployeeDetails = createAsyncThunk(
  "employeeDetails",
  async (userId) => {
    const response = await EmployeeListService.getEmployeeDetails(userId);
    return response;
  }
);


export const updateEmployeeDetails = createAsyncThunk(
  "updateEmployeeDetails",
  async (response) => {
    return response;
  }
);

export const fetchContractor = createAsyncThunk("contractorList", async () => {
  const response = await EmployeeListService.getContractorByPage();
  return response;
});

export const ContractorSlice = createSlice({
  name: "contractor",
  initialState,
  reducers: {
    addContractorColumnConfig: (state, action) => {
      const configs = action.payload;
      let configsToStore = [];
      configs.forEach((config) => {
        configsToStore.push({
          ...config,
          key: config.columnCode,
          options: config.options ? config.options : [],
        });
      });
      state.columnConfig = configsToStore;
    },
    addColumnToContractorColumnConfig: (state, action) => {
      state.columnConfig = [...state.columnConfig, action.payload];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractor.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContractor.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = action.payload;
      })
      .addCase(fetchTenantData.pending, (state) => {
        state.formData.tenantData = "loading";
      })
      .addCase(fetchTenantData.fulfilled, (state, action) => {
        state.status = "idle";
        state.formData.tenantData = action.payload;
      });
  },
});

export const { addContractorColumnConfig, addColumnToContractorColumnConfig } =
  ContractorSlice.actions;

export const selectContractor = (state) => {
  return state.contractor.data;
};

export const selectTenanatData = (state) => {
  return state.employee.formData.tenantData;
};

export const selectEmployeeData = (state) => {
  return state.employee.formData.selectedEmployee;
};

export default ContractorSlice.reducer;
